'use strict';

module.exports = {
	maxNumber: function(ctrl, value, limit) {
		var max = parseFloat(limit, 10);
		return ctrl.$isEmpty(value) || isNaN(max) || value <= max;
	},
	minNumber: function(ctrl, value, limit) {
		var min = parseFloat(limit, 10);
		return ctrl.$isEmpty(value) || isNaN(min) || value >= min;
	}
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-input-masks/src/helpers/validators.js
 ** module id = 19
 ** module chunks = 1
 **/